export const theme = {
    primaryColor: '#1b90fa',
    lightBlue: '#f0f3fa',
    color: '#333',
    primaryDarkColor: '#192758',
    dangerColor: '#e84157',
    grayColor: '#333333',
    grayColor2: '#626366',
    grayColor3: '#b0b3b8',
    grayColor4: '#cdd0d6',
    grayColor5: '#e7ecf2',
    fontSize: '14px',
    headerFontSize: '18px',
    smallFontSize: '12px',
    primaryFontSize: '14px',
    header: {
        height: '80px'
    },
    sidebar: {
        backgroundColor: '#192758',
        width: '320px'
    }
};
